// Champions League Game Constants
// 
// VIGTIGT: Denne fil skal holdes synkroniseret med:
// backend/src/constants.js
// 
// Når point-værdier ændres, skal begge filer opdateres!

// TEAMS vil nu hentes dynamisk fra database
export const TEAMS = []; // Placeholder - vil blive overskrevet af dynamiske data

export const PHASES = [
  { id: 0, name: 'Fase 0 - Gæt Vinderen', description: 'Vælg hvem du tror vinder Champions League' },
  { id: 1, name: 'Fase 1 - Liga', description: 'Gæt rækkefølgen af alle 36 hold' },
  { id: 2, name: 'Fase 2 - Knockout', description: 'Gæt på playoff og knockout kampe' },
  { id: 3, name: 'Fase 3 - Finalen', description: 'Gæt vinderen af finalen' }
];

export const POINT_SYSTEM = {
  PRESEASON_WINNER: 10,
  PRESEASON_FINALIST: 3,
  // Kategori-baseret system: Bonus KUN hvis gæt og faktisk er i samme kategori
  LEAGUE_EXACT_POSITION: 2,       // Præcis position korrekt
  LEAGUE_TOP_8_BONUS: 1,          // Både gæt OG faktisk i top 8 (1-8)
  LEAGUE_PLAYOFF_BONUS: 0.5,      // Både gæt OG faktisk i playoff (9-24)
  LEAGUE_OUT_BONUS: 0.5,          // Både gæt OG faktisk ude (25-36)
  PLAYOFF_MATCH: 1,
  EIGHTH_FINAL_MATCH: 1,
  QUARTER_FINAL_MATCH: 1,
  SEMI_FINAL_MATCH: 1,
  FINAL_WINNER: 1,
  FINAL_BOTH_CORRECT: 2
};

export const LEAGUE_POSITIONS = {
  TOTAL_TEAMS: 36,
  TOP_8: 8,
  PLAYOFF_START: 8,
  PLAYOFF_END: 24,
  OUT_START: 24
};

export const KNOCKOUT_MATCHES = {
  PLAYOFF: 8,
  EIGHTH_FINALS: 8,
  QUARTER_FINALS: 4,
  SEMI_FINALS: 2,
  FINAL: 1
};
